import React from 'react'
import styled from 'styled-components'
import NoteOutlinedIcon from '@mui/icons-material/NoteOutlined'
import Card from 'pages/HehmDevice/HehmDashboard/Card'

import { color } from 'styles/colors'

import HehmDevice from 'types/HehmDevice'
import { DeviceBase } from 'types/Device'

type Props = {
  data?: HehmDevice
  onNavigate: (tab: string) => void
  device?: DeviceBase
}

const NotesCard = ({ onNavigate, device }: Props) => {
  const notes = device?.note

  return (
    <Card
      title="Notes"
      iconNode={<S.NoteIcon />}
      onClick={() => onNavigate('notes')}
    >
      <S.NotesTile>
        <S.ClampedValue>
          {notes || <S.Placeholder>Add Notes Here</S.Placeholder>}
        </S.ClampedValue>
      </S.NotesTile>
    </Card>
  )
}

export default NotesCard

const S = {
  NoteIcon: styled(NoteOutlinedIcon)`
    display: inline-block;
    width: 40px !important;
    height: 40px !important;
    font-size: 40px !important;
    margin-right: 5px;
    transform: rotate(90deg);
    color: ${color('ancillaryText')};
    opacity: 0.7;
  `,
  Placeholder: styled.span`
    color: ${color('ancillaryText')};
    font-style: italic;
    opacity: 0.6;
  `,
  NotesTile: styled.div`
    width: 100%;
    max-width: 500px;
    min-width: 0;
    height: 75px;
    transform: rotate(0deg);
    opacity: 1;
    border-radius: 12px;
    gap: 10px;
    padding: 12px;
    background-color: ${color('notesCardBackground')};
    box-sizing: border-box;
    @media (max-width: 600px) {
      max-width: 100%;
      height: auto;
      padding: 8px;
    }
  `,
  ClampedValue: styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    max-height: calc(1.5em * 3);
    margin-bottom: 15px;
    background-color: ${color('notesCardBackground')};
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 1.5;
    letter-spacing: 1;
    text-box-trim: none; 
    color: ${color('primaryText')};
  `
}
